import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import { Title, useTranslate } from 'react-admin';
import ModerationQueuePanel from '../components/Marketplace/Operator/ModerationQueuePanel';
import OperatorOrdersPanel from '../components/Marketplace/Operator/OperatorOrdersPanel';
import OperatorSettlementsPanel from '../components/Marketplace/Operator/OperatorSettlementsPanel';
import OperatorWebhookEventsPanel from '../components/Marketplace/Operator/OperatorWebhookEventsPanel';
import OperatorDatevPanel from '../components/Marketplace/Operator/OperatorDatevPanel';
import OperatorReviewsPanel from '../components/Marketplace/Operator/OperatorReviewsPanel';

export const OPERATOR_SECTIONS = ['moderation', 'orders', 'settlements', 'events', 'datev', 'reviews'] as const;
export type OperatorSection = typeof OPERATOR_SECTIONS[number];

export const operatorPath = (section: OperatorSection): string => `/platform/marketplace/${section}`;

/**
 * Operator-Bereich des Marktplatzes (Marktplatz-Rework T9): Moderation, Bestellungen mit Refund,
 * Abrechnung, Zahlungsereignisse, DATEV-Export und Bewertungen unter `/platform/marketplace/:section`.
 */
const PlatformMarketplacePage: React.FC<{ section?: OperatorSection }> = ({ section = 'moderation' }) => {
    const translate = useTranslate();

    return (
        <Box>
            <Title title={translate('marketplaceOperator.title')} />
            {/* Der Seitentitel kommt aus der TitleBar des Layouts (`.page > h1`) — kein zweiter h1 */}
            <Typography variant="body1" sx={{ mb: 2, color: 'var(--oa-text-2)', maxWidth: 760 }}>{translate('marketplaceOperator.intro')}</Typography>

            <Tabs
                value={section}
                variant="scrollable"
                scrollButtons="auto"
                aria-label={translate('marketplaceOperator.title')}
                sx={{ mb: 3, borderBottom: '1px solid var(--oa-divider)' }}
            >
                {OPERATOR_SECTIONS.map((s) => (
                    <Tab key={s} value={s} component={Link} to={operatorPath(s)} label={translate(`marketplaceOperator.nav.${s}`)} data-testid={`tab-${s}`} />
                ))}
            </Tabs>

            {section === 'moderation' && <ModerationQueuePanel />}
            {section === 'orders' && <OperatorOrdersPanel />}
            {section === 'settlements' && <OperatorSettlementsPanel />}
            {section === 'events' && <OperatorWebhookEventsPanel />}
            {section === 'datev' && <OperatorDatevPanel />}
            {section === 'reviews' && <OperatorReviewsPanel />}
        </Box>
    );
};

export default PlatformMarketplacePage;
